import type { FC } from "react";
import React from "react";
import { useBrand } from "@edreamsodigeo/frontend-core";
import { Pill } from "@edreamsodigeo/prisma-design-system";

import type { LightboxPinProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxPill/types";
import lightboxPillStyles from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxPill/styles";

const LightboxPill: FC<LightboxPinProps> = ({ type, rounded, children }) => {
  const brand = useBrand();
  return (
    <Pill
      type={type}
      rounded={rounded}
      style={{
        color:
          lightboxPillStyles[brand][type]?.color ??
          lightboxPillStyles[brand].default.color,
      }}
    >
      {children}
    </Pill>
  );
};

export default LightboxPill;
